export enum EnumRouteType {
	GET    = 'GET',
	POST   = 'POST',
	DELETE = 'DELETE',
	PUT    = 'PUT',
	PATCH  = 'PATCH'
}
